import Cookies from 'vue-cookies';
import { consents } from '@/utils/borlabsCookie';

// const CLIDS = ['gclid', 'fbclid', 'madid', 'msclkid'];

const CLIDS = [
  {
    src: 'gclid',
    cookieName: 'afl_wc_utm_gclid_url',
  },
  {
    src: 'fbclid',
    cookieName: 'afl_wc_utm_fbclid_url',
  },
  {
    src: 'madid',
    cookieName: 'afl_wc_utm_madid_url',
  },
  {
    src: 'msclkid',
    cookieName: 'afl_wc_utm_msclkid_url',
  },
];

export function setConversionCookie(query) {
  if (consents.essential.includes('conversion')) {
    const src = CLIDS.find(id => query[id]);
    if (src) {
      Cookies.set(src, { id: query[src], created: new Date().getTime() }, '30d');
    }
  }
}

function extractClidIdFromURIComponent(uri, src) {
  if (uri === null) return uri;
  return new URL(decodeURIComponent(uri)).searchParams.get(src);
}

export function getConversionCookie() {
  const availableClids = CLIDS.map(clid => ({
    src: clid.src,
    id: extractClidIdFromURIComponent(Cookies.get(clid.cookieName), clid.src),
  })).filter(clid => clid.id);

  const trackingOrigin = {
    TrackingOrigin: availableClids.map(clid => ({
      __component: 'tracking.tracking-origin',
      TrackingID: clid.id,
      TrackingSource: clid.src,
    })),
  };
  return trackingOrigin;
}

/* opt in code in the wordpress borlabs plugin

<script>
const CLIDS = ['gclid', 'fbclid', 'madid'];

// const query = new URL(document.location).searchParams;

const queryObj = decodeURIComponent(document.location.search)
  .slice(1)
  .split('&')
  .reduce(function(acc, param) {
    const match = param.split('=');
    acc[match[0]] = match[1];
    return acc;
  }, {});

const src = CLIDS.find(function (src) {
  // return query.get(src);
  return queryObj[src];
});

function daysFromNow(days) {
  const now = new Date();
  return new Date(now.setUTCDate(now.getUTCDate() + days)).toUTCString();
}

if (src) {
  document.cookie = `${src}=${queryObj[src]}; expires=${daysFromNow(30)};`;
}
</script>
*/
